import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination, Modal, Form } from 'react-bootstrap';
import { Subtitle } from '../../components/SubTitle';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPen, FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';
import DynamicTable from '../../components/DynamicTable';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import CircularProgress from '@mui/material/CircularProgress';
import { Autocomplete, TextField } from '@mui/material';
import _ from 'lodash';
import { VincularExames } from '../VincularExames';

export function TabelaBalcao() {

    interface Company {
        id: number;
        nome: string;
    }

    const [isLoading, setIsLoading] = useState(false);
    const [observacao, setObservacao] = useState('');
    const [nome, setNome] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(0);
    const [employees, setEmployees] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);
    const [searchQuery, setSearchQuery] = useState('');
    const [exames, setExames] = useState([]);
    const [companies, setCompanies] = useState<Company[]>([]);
    const [paramCompany, setParamCompany] = useState(0);
    const [selectedTableType, setSelectedTableType] = useState('');
    const [tipo, setTipo] = useState(null);
    const [headerColor, setHeaderColor] = useState('#ccc');
    const [cor, setCor] = useState('#000000');
    const [show, setShow] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const [idSelected, setIdSelected] = useState('');
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [isEditing, setIsEditing] = useState(false);
    const [selectedTable, setSelectedTable] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedCheckboxTables, setSelectedCheckBoxTables] = useState<any>([]);
    const [selectedExam, setSelectedExam]: any = useState(null);
    const [baseExames, setBaseExames] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [valorVenda, setValorVenda]: any = useState(null);
    const [valorReaproveitamento, setValorReaproveitamento]: any = useState(null);

    const showModal = async (id: any, tipo: string, cor: string) => {
        setIdSelected(id);
        setSelectedTableType(tipo);
        setShow(true);
        setHeaderColor(cor);
    }

    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    const currentEmployees = exames.slice(indexOfFirstEmployee, indexOfLastEmployee);

    const filteredEmployees = exames.filter((exame: any) => {
        return (
            exame.exames.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
            exame.exames.id.toString().includes(searchQuery)
        );
    });

    // Paginação após filtragem
    const indexOfLastExam = currentPage * employeesPerPage;
    const indexOfFirstExam = indexOfLastExam - employeesPerPage;
    const currentExams = filteredEmployees.slice(indexOfFirstExam, indexOfLastExam);

    const handleClose = () => setShow(false);

    const handleCloseEditModal = () => setShowEditModal(false);

    const handleCloseRegisterModal = () => {
        setIsEditing(false);
        setTipo(null);
        setNome('');
        setCor('');
        setObservacao('');
        setShowRegisterModal(false);
        setValorReaproveitamento('');
        setValorVenda('');
        setSelectedExam(null);
    }

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1);
    };

    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        if (selectedCompany !== null) {
            fetchExams(selectedCompany);
        }
    }, [selectedCompany]);



    const fetchExams = async (companyId: number) => {
        try {
            setExames([])
            setLoading(true)
            let tables = null;
            if (companyId === 0) {
                tables = await api.get(`listar-exames-tabela-balcao`);
            } else {
                tables = await api.get(`listar-exames-tabela-balcao/${companyId}`);
            }
            const responseData = tables.data;
            setExames(responseData);
            setLoading(false)
            console.log(exames)
        } catch (error) {
            setLoading(false)
            console.error("Error fetching exams:", error);
        }
    };

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    const handleSelectCompany = (id: number) => {
        setSelectedCompany(id);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const debouncedFetchExames = _.debounce(async (nome: string) => {
        if (!nome) return; // Evita buscar se não houver input
        setLoading(true);
        try {
            const response = await api.get(`listar-base-exames/${nome}`);
            setBaseExames(response.data);
        } catch (error) {
            console.error("Erro ao buscar exames:", error);
            setBaseExames([]);
        } finally {
            setLoading(false);
        }
    }, 200);

    const handleSubmit = async () => {
        try {
            let response
            if (selectedCompany === 0) {
                const data = {
                    id_exame: selectedExam.id,
                    valor_venda: valorVenda,
                    valor_venda_rea: valorReaproveitamento
                }

                response = await api.post('inserir-exames-tabela-balcao', data);
            } else {
                const data = {
                    id_exame: selectedExam.id,
                    id_empresa: selectedCompany,
                    valor_venda: valorVenda,
                    valor_venda_rea: valorReaproveitamento
                }
                response = await api.post('inserir-exames-tabela-balcao-empresa', data);
            }

            if (response.status == 200 || response.status == 204) {
                fetchExams(selectedCompany);
                handleClose();
            }
        } catch (error) {
            console.error("Erro ao buscar exames:", error);
        }
    }

    const handleEdit = async (exameId: number) => {
        try {
            let response
            if (selectedCompany === 0) {
                response = await api.post(`buscar-exame-selecionado/${exameId}`)
            }
            else {
                response = await api.post(`buscar-exame-selecionado-empresa/${selectedCompany}/${exameId}`)
            }
            const data = {
                id: response.data.id_exame,
                label: response.data.exames.nome
            }

            if (response.status == 200) {
                setValorVenda(response.data.valor_venda);
                setValorReaproveitamento(response.data.valor_venda_rea);
                setSelectedExam(data);
                setIsEditMode(true);
                setShowRegisterModal(true);
            }

        } catch (error) {
            console.error("Erro ao editar exames", error)
        }
    }

    const handleDeleteExam = async (exameId: number) => {
        try {
            let response;
            if (selectedCompany === 0) {
                response = await api.post(`excluir-exame-padrao/${exameId}`);
            } else {
                response = await api.post(`excluir-exame-padrao-empresa/${selectedCompany}/${exameId}}`)
            }
            if (response.status == 200) {
                fetchExams(selectedCompany);
            }
        } catch (error) {
            console.error("Erro ao excluir exames", error)
        }
    }

    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            const companiesData = response.data.message ? [] : response.data;
            const defaultOption = { id: 0, nome: "Padrão" };
            setCompanies([defaultOption, ...companiesData]);
            setSelectedCompany(0); // Seleciona "Padrão" por padrão
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary">
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <CardContent>
                    <Col md={5}>
                        <Title text="Empresa" />
                        <Select width="600px" id='empresas' onSelect={handleSelectCompany}>
                            {companies.map((company, index) => (
                                <Options
                                    key={company.id}
                                    value={company.id}
                                    name={company.nome}
                                    selected={company.id === selectedCompany}
                                />
                            ))}
                        </Select>
                    </Col>
                </CardContent>

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Tabela de Preço Balcão" />
                        <Col md={8} className='newbutton'>
                            <Button className='btn-main' onClick={() => setShowRegisterModal(true)}><FillPlus /> Novo Exame</Button>
                        </Col>
                        <Col md={4}>
                            <Search placeHolder="Procure pelo nome" onChange={handleSearchChange} />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(exames.length / employeesPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                <table >
                                    <thead>
                                        <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Exame</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Valor de Venda</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Valor do Reaproveitamento</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentExams && currentExams.length > 0 ? (
                                            currentExams.map((exame: any, index: number) => {
                                                return (
                                                    <tr key={exame.id}>
                                                        <td style={{ fontSize: '13px', padding: '15px' }}>
                                                            {exame.exames.nome}
                                                            <div style={{ fontSize: '12px', color: '#777', marginTop: '5px', fontWeight: 'bold' }}>
                                                                {!exame.id_empresa && !exame.parceiro ? (
                                                                    <>
                                                                        Valor padrão
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {exame.parceiro?.nome ? exame.parceiro?.nome : "Valor empresa"}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{ fontSize: '13px', padding: '15px' }}>
                                                            R$ {exame.valor_venda}
                                                        </td>
                                                        <td style={{ fontSize: '13px', padding: '15px' }}>
                                                            R$ {exame.valor_venda_rea}
                                                        </td>
                                                        <td style={{ fontSize: '13px', padding: '15px' }}>
                                                            {exame.parceiro ? (
                                                                <>
                                                                    <div style={{ fontSize: '12px', color: '#777', marginBottom: '5px', fontWeight: 'bold' }}>
                                                                        Exame se encontra na base de dados Atento
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Button variant='outline-main' onClick={() => handleEdit(exame.exames.id)}>Editar</Button>
                                                                    <Button style={{ backgroundColor: 'red', border: 'none', marginLeft: '10px' }} onClick={() => handleDeleteExam(exame.id_exame)}>Excluir</Button>
                                                                </>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td style={{ padding: '15px' }}>
                                                    Nenhum exame disponível
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Row>
                            {selectedCheckboxTables.length > 0 && (
                                <div style={{ marginTop: '20px', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                    <Button style={{ backgroundColor: 'red', color: 'white', border: 'none' }}>
                                        Excluir Selecionados
                                    </Button>
                                </div>
                            )}
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
                <Modal show={showRegisterModal} onHide={handleCloseRegisterModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{isEditMode ? 'Editar Exame' : 'Cadastrar Exame'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col xs={12} md={8} xl={8}>
                                    <FormGroup className='form-group-dsg'>
                                        <Label title="Nome (DIGITE E SELECIONE)" htmlFor="exa" />
                                        <Autocomplete
                                            key={selectedExam ? selectedExam.id : 'empty'}
                                            value={selectedExam}
                                            noOptionsText="Digite e selecione"
                                            style={{ width: '100%', height: '40px' }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label=""

                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }} />
                                            )}
                                            options={baseExames.map((exame: any) => ({ label: exame.nome, id: exame.id }))}
                                            getOptionLabel={(option) => option.label}
                                            getOptionDisabled={(option) => currentExams.some((exame: { id_exame: any; }) => exame.id_exame === option.id)}
                                            onChange={(event, newValue) => {
                                                setSelectedExam(newValue);
                                            }}
                                            onInputChange={(event, newValue) => {
                                                debouncedFetchExames(newValue);
                                            }}
                                            isOptionEqualToValue={(option, value) => option.id === value.id} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={8} xl={8} style={{ marginTop: '30px' }}>
                                    <FormGroup>
                                        <Label title='Valor de Venda' htmlFor="cor" />
                                        <input
                                            className='corColuna'
                                            type="number"
                                            id="cor"
                                            value={valorVenda}
                                            onChange={(e) => setValorVenda(e.target.value)}
                                            style={{ marginRight: '10px', marginBottom: '10px', width: '100%', height: '40px' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={8} xl={8}>
                                    <FormGroup>
                                        <Label title='Valor do Reaproveitamento' htmlFor="cor" />
                                        <input
                                            className='corColuna'
                                            type="number"
                                            id="cor"
                                            value={valorReaproveitamento}
                                            onChange={(e) => setValorReaproveitamento(e.target.value)}
                                            style={{ marginRight: '10px', marginBottom: '10px', width: '100%', height: '40px' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={handleSubmit}>
                            Salvar
                        </Button>
                        <Button variant="secondary" onClick={handleCloseRegisterModal}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}